module.exports = __webpack_public_path__ + "assets/images/rbyearend-07.jpg?v=853055b9";